import Layout from './component'

export default Layout